<template>
  <v-card>
    <v-card-text>
      <div class="d-none d-md-flex">
        <v-row>
          <v-col cols="2" class="d-flex align-center justify-center">
            <v-img
                src="@/assets/images/logo_FE_Inteligentny_Rozwoj_rgb-1.webp"
                height="110"
                width="420"
                contain
            ></v-img>
          </v-col>
          <v-col cols="2" class="d-flex align-center justify-center">
            <v-img
                src="@/assets/images/Barwy_RP_1.webp"
                height="100"
                width="400"
                contain
            ></v-img>
          </v-col>
          <v-col cols="2" class="d-flex align-center justify-center">
            <v-img
                src="@/assets/images/UE_EFRR_rgb-1.webp"
                height="100"
                width="400"
                contain
            ></v-img>
          </v-col>
          <v-col cols="6" class="d-flex align-center justify-center">
            <div class="pa-7 text-justify">
              Telnet Systemy Teleinformatyczne Sp. z o.o. realizuje projekt
              dofinansowany z Funduszy Europejskich „Opracowanie nowej wersji
              systemu do monitorowania temperatury w silosach zbożowych DEMETER
              zgodnie z ideą ekoprojektowania”
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="d-block d-md-none">
        <v-row>
          <v-col cols="4">
            <v-img
                src="@/assets/images/logo_FE_Inteligentny_Rozwoj_rgb-1.webp"
                height="50"
                width="140"
                contain
            ></v-img>
          </v-col>
          <v-col cols="4">
            <v-img
                src="@/assets/images/Barwy_RP_1.webp"
                height="50"
                width="140"
                contain
            ></v-img>
          </v-col>
          <v-col cols="4">
            <v-img
                src="@/assets/images/UE_EFRR_rgb-1.webp"
                height="50"
                width="140"
                contain
            ></v-img>
          </v-col>
        </v-row>
        <div class="pa-7 text-justify">
          Telnet Systemy Teleinformatyczne Sp. z o.o. realizuje projekt
          dofinansowany z Funduszy Europejskich „Opracowanie nowej wersji
          systemu do monitorowania temperatury w silosach zbożowych DEMETER
          zgodnie z ideą ekoprojektowania”
        </div>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-expansion-panels style="border-radius: 0">
      <v-expansion-panel>
        <v-expansion-panel-header>
          Więcej informacji
        </v-expansion-panel-header>
        <v-expansion-panel-content class="grey--text" aria-expanded="undefined">
          Celem projektu jest opracowanie sprzyjającego ochronie środowiska
          systemu i urządzeń na potrzeby przechowalnictwa płodów rolnych w
          postaci systemu monitorowania temperatury w silosach zbożowych.
          Przeznaczeniem systemu będzie monitorowanie temperatury (a pośrednio
          wilgotności) ziaren zbóż celem wykrywania zagrzewania, a tym samym
          ograniczenia strat z tym związanych.<br/>

          Rezultat projektu – nowy system Eko-Demeter umożliwi ofertowanie
          klientom nowego rozwiązania i zastąpienie starych instalacji
          rozwiązaniem nowoczesnym, a przy tym przyjaznym środowisku
          (wykorzystując przynajmniej część istniejącej infrastruktury).

          <br/><br/>Dofinansowanie projektu z UE: 335 085,93 PLN

          <br/>Wartość projektu ogółem: 484 889,06 PLN
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
export default {
  name: "EuropeanUnionComponent"
};
</script>

<style scoped></style>
